<template>
  <div class="app">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col cols="2">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col cols="1">
          <v-switch dense v-model="form.active" label="Ativo" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.departament_id"
            :items="departaments"
            label="departamento"
            @change="getDepartament(form.departament_id)"
            @input="$v.form.departament_id.$touch()"
            @blur="$v.form.departament_id.$touch()"
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import { registerVuexModule } from '@/utils/vuexUtils'

import tarefasStore from '../_store'
import { validateData, validateComputed } from '../_validates/validateDeslogarDepartamento'

export default {
  name: 'DeslogarDepartamento',
  props: {
    acao: Object,
  },
  mixins: [validationMixin],
  data: () => ({
    form: {
      active: true,
      description: 'DESLOGAR DEPARTAMENTO',
      tipo: 'deslogarDepartamento',
      departament_id: '',
      departament_name: '',
    },
    departaments: [],
    showSkeleton: true,
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('acaoDeslogarDepartamentoAgendamentoTarefaModulePABXStore', ['getDepartaments']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'acaoDeslogarDepartamentoAgendamentoTarefaModulePABXStore', tarefasStore)

    await this.listarDepartamentos()

    this.departaments = this.getDepartaments.map(departamento => ({
      text: `${departamento.description}`,
      value: departamento._id,
    }))

    this.form = Object.assign({}, this.acao)
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('acaoDeslogarDepartamentoAgendamentoTarefaModulePABXStore', ['listarDepartamentos']),

    getDepartament(departament_id) {
      if (departament_id) {
        const operador = this.getDepartaments.filter(departamento => departamento._id === departament_id)
        this.form.departament_name = `${operador[0].description}`
      }
    },
  },

  watch: {
    form: {
      deep: true,
      handler(novo) {
        this.$emit('form', novo)
        this.$emit('error', this.$v)
      },
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>